import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Header from "../../assets/components/header";
import Footer from "../../assets/components/footer";
import DataTable from "../../assets/components/dataTable";
import NotificationActions from "../../store/actions/notification";
import MemberSearchSelect from "../../assets/components/MemberSearchSelect";
import EventCancellation from "../../models/EventCancellation";
import moment from "moment";
import MemberChip from "../../assets/components/MemberChip";

class CancellationsIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            table: {
                page: 1,
                term: "",
                sort: "cancelledAt",
                order: "desc",
                limit: 25,
            },
            filters: {
                member: null,
            },
            totalRecords: 0,
            cancellations: [],
            notification: null,
            error: false,
        };

        if (this.props.user.has("MASHIE_ADMIN") === false) {
            this.props.history.push("/members");
        }
    }

    componentWillUnmount() {
        this.props.dispatch(NotificationActions.remove());
    }

    notification(type, text) {
        this.props.dispatch(NotificationActions.create({ type, text }));
    }

    table() {
        const headers = [
            { key: "event", text: "Event" },
            { key: "venue", text: "Venue" },
            { key: "member", text: "Member" },
            { key: "players", text: "Players" },
            { key: "eventDate", text: "Event date" },
            { key: "cancellationDate", text: "Cancellation date" },
        ];

        const data = this.state.cancellations.map((cancellation) => {
            const venue = cancellation.event?.club ?? null;
            return {
                event: {
                    value: cancellation.event ? (
                        <Link to={`/events/${cancellation.event._id}`}>
                            {cancellation.event.name}
                        </Link>
                    ) : (
                        "Event not found"
                    ),
                    search: cancellation.event?.name ?? "Event not found",
                },
                venue: {
                    value: venue ? (
                        <Link to={`/golf-clubs/${venue._id}`}>
                            {venue.name}
                        </Link>
                    ) : (
                        "Venue not found"
                    ),
                    search: venue?.name ?? "Venue not found",
                },
                member: {
                    value: <MemberChip member={cancellation.user} />,
                    search: cancellation.user.name,
                },
                players: { value: cancellation.players },
                eventDate: {
                    value: cancellation.event
                        ? moment(cancellation.event.date).format("DD/MM/YYYY")
                        : "",
                },
                cancellationDate: {
                    value: moment(cancellation.createdAt).format(
                        "DD/MM/YYYY HH:mm:ss",
                    ),
                },
            };
        });

        return (
            <DataTable
                loading={this.state.loading}
                headers={headers}
                data={data}
                totalRecords={this.state.totalRecords}
                page={this.state.table.page}
                onChange={this.getCancellations.bind(this)}
                searchTerm={this.state.table.term}
                sort={this.state.table.sort}
                order={this.state.table.order}
                limit={this.state.table.limit}
                sortOptions={[
                    { text: "Cancelled", key: "cancelledAt" },
                    { text: "Creation", key: "createdAt" },
                    { text: "Event", key: "event" },
                    { text: "Players", key: "players" },
                    { text: "Member", key: "user" },
                ]}
                pagination
            />
        );
    }

    getCancellations(params) {
        this.setState({ loading: true });
        EventCancellation.index(Object.assign(params, this.state.filters))
            .then((data) => {
                this.setState({
                    table: params,
                    totalRecords: data.total,
                    loading: false,
                    cancellations: data.cancellations,
                });
            })
            .catch((error) => {
                this.setState({ loading: false, error: true });
                this.notification("error", "Failed to load. Please try again");
            });
    }

    componentDidMount() {
        this.getCancellations(this.state.table);
    }

    onChangeFilter(property, value) {
        const { filters, table } = this.state;
        filters[property] = value;
        table.page = 1;
        this.setState({ filters, table });
        this.getCancellations(table);
    }

    body() {
        return (
            <div className='container-fluid' style={{ overflowX: "scroll" }}>
                <div className='row page-header mt-3'>
                    <div className='col'>
                        <h2>Event cancellations</h2>
                    </div>
                </div>
                <div className='row mb-3'>
                    <div className='col'>
                        <h3>Filters</h3>
                        <MemberSearchSelect
                            onChange={(value) =>
                                this.onChangeFilter("member", value)
                            }
                            value={this.state.filters.member}
                            placeholder='Filter by member'
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>{this.table()}</div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />

                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        notification: state.notification,
    };
}

export default connect(mapStateToProps)(CancellationsIndex);
